import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  MonthlyFeeInvoicingHold,
  UpcomingFeeInvoices,
} from "./upcomingInvoicesTypes";

/**
 * Admin routes behind the Upcoming invoices tab. `get` is SALES_READ and computes the preview
 * live on each call; `setHold` is SUPER. Below SUPER it answers 404, the same as for an unknown company,
 * so a caller cannot tell a denial from a missing company.
 */
export const upcomingInvoicesApi = {
  get: () =>
    goSolidApi.get<UpcomingFeeInvoices>("/api/admin/upcoming-fee-invoices"),
  setHold: (companyId: number, held: boolean) =>
    goSolidApi.put<MonthlyFeeInvoicingHold>(
      `/api/admin/companies/${companyId}/monthly-fee-invoicing-hold`,
      { held }
    ),
};
